<div class="flight-card mr-small">
  <ng-content select="fcom-notification, [notifications]" />
  <div class="mr-xsmall-t" [class.disabled]="disabled()">
    <!-- LabelDate and TicketType -->

    <div class="flex flex--space-between flex--wrap pr-xsmall-b labels font-body-2 font-body-small">
      <div>
        @if (date()) {
          <span class="label"> {{ type() }} {{ date() }} </span>
        }
        @if (disruptedLabel()) {
          <fcom-tag [theme]="TagTheme.DISRUPTION">{{ disruptedLabel() | finLocalization }}</fcom-tag>
        }
      </div>
      @if (fareDetail()) {
        <fcom-tag>{{ fareDetail() }}</fcom-tag>
      }
    </div>

    <ng-content select="fcom-ufo" />
  </div>

  @if (showDivider()) {
    <div class="border-top-dotted mr-small-t mr-xsmall-b"></div>
  }

  <div class="mr-xsmall-t buttons flex flex--end flex--column hide-empty">
    <ng-content select="fcom-button" />
  </div>
</div>
